<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import SocketManage from '@/util/SocketManage';
import { mapState, mapMutations } from 'vuex';
import DC from "@/util/SocketHandler";
import KeepAlive from '@/util/keepalive';
import {getRolesMenus} from "@/API/login/login";
export default {
  data() {
    return {
      ordinarySocket: null,
      supervisionSocket: null,
      keepAliveManager:null,
      isPageRefreshing:false
    };
  },
  computed: {
    ...mapState(['ordinaryLoggedIn', 'supervisionLoggedIn']),
    wsUrl: () => process.env.VUE_APP_CAGENT_URL
  },
  watch: {
    ordinaryLoggedIn(val) {
      val ? this.initOrdinarySocket() : this.closeOrdinarySocket();
      if (val) this.startKeepalive();
      else this.stopKeepalive();
    },
    // supervisionLoggedIn(val) {
    //   val ? this.initSupervisionSocket() : this.closeSupervisionSocket();
    //   if (val) this.startKeepalive();
    //   else this.stopKeepalive();
    // }
  },
  created() {
    if (this.ordinaryLoggedIn) this.initOrdinarySocket();
    // if (this.supervisionLoggedIn) this.initSupervisionSocket();
    this.keepAliveManager = new KeepAlive(this);
    // if (this.ordinaryLoggedIn || this.supervisionLoggedIn) {
    //   this.startKeepalive();
    // }
    if (this.ordinaryLoggedIn) {
      this.startKeepalive();
    }
    // 注册全局登出处理器
    this.registerLogoutHandlers();
    // 注册会员消息变更通知
    this.registerRolesChange();
  },
  methods: {
    ...mapMutations(['SET_OrdinaryLoggedIn', 'SET_SupervisionLoggedIn']),
    startKeepalive() {
      this.$nextTick(() => {
        this.keepAliveManager.startKeepalive();
      });
    },
    stopKeepalive() {
      this.keepAliveManager.stopKeepalive();
    },
    initOrdinarySocket() {
      const token = localStorage.getItem('ordinaryToken') || sessionStorage.getItem('ordinaryToken');
      if (!token) return;

      this.closeOrdinarySocket();
      this.ordinarySocket = new SocketManage(this.wsUrl, token, 'ordinary');
      this.ordinarySocket.initWebSocket();
    },

    initSupervisionSocket() {
      const token = localStorage.getItem('supervisionToken') || sessionStorage.getItem('supervisionToken');
      if (!token) return;
      this.closeSupervisionSocket();
      this.supervisionSocket = new SocketManage(this.wsUrl, token, 'supervision');
      this.supervisionSocket.initWebSocket();
    },

    registerLogoutHandlers() {
      // 普通用户登出处理
      DC.registerMessageHandler('SYSTEM', 'kickout', (data) => {
        console.log(data,'data.userType111')
        let ordinaryList= [1,2,3] //1-普通用户,2-企业用户,3-政务用户,
        // let supervisionList= [4] //4-监管用户
        if (ordinaryList.includes(data.userType)) {
          this.handleLogout('ordinary', '您的账号已在其他地方登录');
          this.routerJump()
        }
        // if (supervisionList.includes(data.userType)) {
        //   this.handleLogout('supervision', '您的监管账号已在其他地方登录');
        // }
      });
    },
    routerJump(){
      this.$router.push('/Home/pages')
    },
    registerRolesChange() {
      DC.registerMessageHandler('RESOURCE', 'memberStatusChange', (data) => {
        let userInfo = localStorage.getItem('ordinaryUser') ? JSON.parse(localStorage.getItem('ordinaryUser')):null
        if(userInfo) {
          if(userInfo.userDetail.userId == data.userId){
            userInfo.userDetail.memberStartTime = data.memberStartTime
            userInfo.userDetail.memberEndTime = data.memberEndTime
            userInfo.userDetail.memberStatus = data.memberStatus
            localStorage.setItem('ordinaryUser',JSON.stringify(userInfo))
            window.location.reload()
          }
        }
      })
    },

    handleLogout(userType, message) {
      this[`SET_${userType.charAt(0).toUpperCase() + userType.slice(1)}LoggedIn`](false);
      localStorage.removeItem(`${userType}Token`);
      sessionStorage.removeItem(`${userType}Token`);
      this.$store.commit(userType== 'ordinary'?'changeOrdinaryUser':'changeSupervisionUser',null)
      this.$message.error(message);
      // if (userType === 'supervision') {
      //   this.$router.push('/SignIn');
      // } else {
      //   this.$router.push('/Home/pages');
      // }
      this.$router.push('/Home/pages');
    },

    closeOrdinarySocket() {
      if (this.ordinarySocket) {
        this.ordinarySocket.closeConnection();
        this.ordinarySocket = null;
      }
    },

    closeSupervisionSocket() {
      if (this.supervisionSocket) {
        this.supervisionSocket.closeConnection();
        this.supervisionSocket = null;
      }
    },
  },
  beforeDestroy() {
    this.closeOrdinarySocket();
    this.closeSupervisionSocket();
    this.stopKeepalive(); // 关闭保活接口请求
    DC.unregisterMessageHandler('RESOURCE','memberStatusChange')
  }
};
</script>
